/** @jsxImportSource @emotion/react */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MainLoader } from '../../components';
import React from 'react';
import {
  DEFAULT_CANCEL_BUTTON_TEXT,
  DEFAULT_CONFIRM_BUTTON_TEXT,
  DEFAULT_MESSAGE,
  DEFAULT_TITLE,
} from './constants/confirmationDialogDefaultValues';
import { ConfirmationDialogProps } from './models/ConfirmationDialog.models';
import { useConfirmationDialogStyles } from './ConfirmationDialog.styles';

export function ConfirmationDialog(
  props: ConfirmationDialogProps,
): React.ReactElement {
  const styles = useConfirmationDialogStyles();

  return (
    <Dialog
      data-test-id="confirmation-dialog"
      css={styles}
      fullWidth={true}
      maxWidth="sm"
      open={props.isOpened}
      scroll="paper"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" data-test-id="confirmation-dialog-title">
        {props.title ?? DEFAULT_TITLE}
      </DialogTitle>
      <DialogContent>
        {props.loading && <MainLoader fillContainer />}
        <DialogContentText
          id="dialog-description"
          data-test-id="confirmation-dialog-message"
        >
          {props.message ?? DEFAULT_MESSAGE}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.onCancel}
          color="primary"
          data-test-id="confirmation-dialog-cancel-button"
        >
          {props.cancelButtonText ?? DEFAULT_CANCEL_BUTTON_TEXT}
        </Button>
        <Button
          onClick={props.onConfirm}
          color="primary"
          data-test-id="confirmation-dialog-confirm-button"
        >
          {props.confirmButtonText ?? DEFAULT_CONFIRM_BUTTON_TEXT}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
